import { useState } from "react";
import { usePeriodoInventario } from "../../../../contexto/provider/InventarioPeriodosContext.js";
import "./ventana.css";


export default function VentanaPeriodo({ periodo, onClose }) {
  const { cambiarEstado } = usePeriodoInventario();
  const [estado, setEstado] = useState(periodo.estado);

const guardarCambios = async () => {
  const objetoParaActualizar = { periodoId: periodo.id, estado };
  console.log("[VentanaPeriodo] Objeto a guardar:", objetoParaActualizar);

  try {
    const resultado = await cambiarEstado(objetoParaActualizar);
    console.log("[VentanaPeriodo] Cambios guardados correctamente:", resultado);
    onClose();
  } catch (error) {
    console.error("[VentanaPeriodo] Error guardando cambios:", error.message || error);
  }
};
  return (
    <div className="ventana-periodo">
      <h3>Modificar periodo: {periodo.mes}</h3>
      <label>
        Estado:
        <select value={estado} onChange={(e) => setEstado(e.target.value)}>
          <option value="abierto">Abrir Inventario</option>
          <option value="cerrado">Cerrar Inventario</option>
        </select>
      </label>
      <div className="acciones">
        <button onClick={guardarCambios}>Guardar</button>
        <button onClick={onClose}>Cancelar</button>
      </div>
    </div>
  );
}